import Webapi from './webapi'
import auth from '../auth'

const contentType = 'application/vnd.budbee.sms-v1+json'

export const sendSms = (sender, recipient, message) =>
    new Webapi()
        .authorization(auth.get())
        .accept(contentType)
        .contentType(contentType)
        .path('sms')
        .path('send')
        .post({ sender, recipient, message })
